import { jsx as _jsx } from "react/jsx-runtime";
import NotFoundError from '@common/errors/not-found-error';
import styles from './error-page.css';
export function NotFoundPage(props) {
    return (_jsx(NotFoundError, { className: styles.errorPage, fallbackHref: "/", "data-test": "404-not-found-message-page", fallbackMessage: "Navigate to home page", code: "404", message: "Nope, can't find it!", description: "Despite our best efforts, there's nothing here to show you with the URL you requested. Most likely the URL is invalid or you don't have permissions to access the page.", ...props }));
}
